//export const FORMANTS_WIDTH = 470;
//export const FORMANTS_HEIGHT= 200;

export const FORMANTS_WIDTH = 200;
export const FORMANTS_HEIGHT= 100;
